// What the native app blocker should be told for the current Clock-In state.
//
// `armed` is the only way in: it's set by an actual Start/Resume tap with
// "Block apps for this session" ticked, never inferred from the clock merely
// running — several paths restore a paused clock with no tap at all.
//
// `until` is the epoch ms at which blocking lapses by itself, so a timer that
// runs out while Clarity is closed stops blocking without any JS running.
// 0 means no end: a stopwatch, or a paused timer (pausing keeps apps blocked).
export function appBlockingState({ armed, sessionRunning, doneCurrent, stopwatch, paused, startMs, durationMs }) {
  const active = !!(armed && sessionRunning && !doneCurrent);
  const timed = active && !stopwatch && !paused && startMs != null && durationMs != null;
  return { active, until: timed ? Math.round(startMs + durationMs) : 0 };
}
